import { render, staticRenderFns } from "./AssetPreviewBox.vue?vue&type=template&id=0055e867&scoped=true"
import script from "./AssetPreviewBox.vue?vue&type=script&lang=js"
export * from "./AssetPreviewBox.vue?vue&type=script&lang=js"
import style0 from "./AssetPreviewBox.vue?vue&type=style&index=0&id=0055e867&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0055e867",
  null
  
)

export default component.exports